/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import s from './Listings.module.css'

// Вынесенные функции API для переиспользования и чистоты компонента
const api = {
  fetchListingCollection: async (id) => {
    const apiToken = localStorage.getItem('apiToken')
    const response = await fetch(`/api/v3/listing_collections/${id}`, {
      headers: {
        API_TOKEN: apiToken,
        Accept: 'application/json',
        ContentType: 'application/json',
      },
      method: 'GET',
    })
    return response.json()
  },

  fetchListings: async (ids) => {
    const apiToken = localStorage.getItem('apiToken')
    const queryString = ids.map((id) => `ids[]=${encodeURIComponent(id)}`).join('&')
    const response = await fetch(`/api/v3/listings/fetch.json?${queryString}`, {
      headers: {
        API_TOKEN: apiToken,
        Accept: 'application/json',
        ContentType: 'application/json',
      },
      method: 'GET',
    })
    return response.json()
  },

  removeListing: async (collectionId, listingId) => {
    const apiToken = localStorage.getItem('apiToken')
    const response = await fetch(`/api/v3/listing_collections/${collectionId}/remove_listing`, {
      headers: {
        'API_TOKEN': apiToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
      body: JSON.stringify({ listing_id: listingId }),
    })
    return response.json()
  },
}

export function Listings({ id }) {
  const [inProgress, setInProgress] = useState(false)
  const [listings, setListings] = useState([])
  const [error, setError] = useState(null)

  const fetchListingsData = useCallback(async () => {
    try {
      setInProgress(true)
      setError(null)

      const collectionData = await api.fetchListingCollection(id)
      if (!collectionData?.listing_ids) return

      const listingsData = await api.fetchListings(collectionData.listing_ids)
      if (listingsData.length > 0) {
        setListings(listingsData)
      }
    } catch (err) {
      setError('Failed to load listings')
      console.error('Fetch listings error:', err)
    } finally {
      setInProgress(false)
    }
  }, [id])

  useEffect(() => {
    fetchListingsData()
  }, [fetchListingsData])

  const handleRemoveFromCollection = useCallback(
    async (listingId) => {
      try {
        setInProgress(true)
        await api.removeListing(id, listingId)

        // Оптимистичное обновление UI
        setListings((prev) => prev.filter((item) => item.id !== listingId))
      } catch (err) {
        setError('Failed to remove listing')
        console.error('Remove listing error:', err)
      } finally {
        setInProgress(false)
        fetchListingsData()
      }
    },
    [id, fetchListingsData]
  )

  const renderContent = () => {
    if (inProgress && listings.length === 0) {
      return <div className={s.inform}>Loading...</div>
    }

    if (error) {
      return <div className={s.inform}>{error}</div>
    }

    if (listings.length === 0) {
      return <div className={s.inform}>Your Collections are empty</div>
    }

    return (
      <div className={s.collections}>
        {listings.map((collection) => (
          <div key={collection.id} className={s.collection}>
            <div className={s.collectionImage}>
              {collection.image?.thumb ? (
                <img
                  className={s.collectionImageElem}
                  src={collection.image.thumb}
                  alt={collection.short_address}
                  loading="lazy"
                />
              ) : (
                <div className={s.noImage}>{collection.id}</div>
              )}
            </div>
            <div className={s.collectionName}>{collection.short_address}</div>
            <div className={s.controls}>
              <button
                disabled={inProgress}
                type="button"
                className={s.button}
                onClick={() => handleRemoveFromCollection(collection.id)}
                aria-label={`Remove ${collection.short_address}`}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={s.root}>
      <div className={s.title}>Listings</div>
      {renderContent()}
    </div>
  )
}

Listings.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
